export interface PartesTranslations {
    TABLE: {
      NAME: string;
      ACTIONS: string;
      BUTTON: string;
      PARTES: string;
      RAZON_SOCIAL: string;
      TIPO_PARTE: string;
      IMPUESTO: string;
      IMPUTABLE: string;
    };
    // Aquí puedes añadir más secciones de traducción según lo necesites
  
    // Esta línea es la clave para que el objeto sea indexable por TypeScript
    [key: string]: any;  // Usamos 'any' para simplificar, pero podrías ser más específico si quieres
  }
  
  export const partesTranslations: { [language: string]: PartesTranslations } = {
    en: {
      TABLE: {
        NAME: "Name",
        ACTIONS: "Actions",
        BUTTON: "New Part",
        PARTES: "Part",
        RAZON_SOCIAL: "Part Name",
        TIPO_PARTE: "Part Type",
        IMPUESTO: "% tax",
        IMPUTABLE: "% chargeable"
      },
    },
    es: {
      TABLE: {
        NAME: "Nombre",
        ACTIONS: "Acciones",
        BUTTON: "Nueva parte",
        PARTES: "Partes",
        RAZON_SOCIAL: "Razón social",
        TIPO_PARTE: "Tipo",
        IMPUESTO: "% impuesto",
        IMPUTABLE: "% imputable"
      },
    }
  };
  